import ContentLoader from 'react-content-loader';
import styles from './gift-item-skeleton.module.css';
import { useMemo, type FC } from 'react';
import { type GiftItemProps } from './gift-item-skeleton.types';
import { cn } from '../../utils/cn';

export const GiftItemSkeleton: FC<GiftItemProps> = ({ width = 331, height = 60, containerClassName }) => {
    const data = useMemo(() => {
        const padding = 10;
        const radius = 12;

        const imageSize = 42;

        const radioSize = 14;
        const radioY = imageSize / 2 - radioSize / 2 + padding;
        const radioX = padding;

        const imageX = padding + radioSize + radioX;
        const imageY = padding;

        const contentX = radioX + radioSize + imageSize + padding * 2;

        const titleHeight = 14;
        const titleWidth = width - contentX - padding;

        return {
            padding,
            radius,
            radioSize,
            imageSize,
            radioY,
            radioX,
            imageX,
            imageY,
            contentX,
            titleWidth,
            titleHeight,
        };
    }, [width]);

    const { padding, radius, radioSize, imageSize, radioY, radioX, imageX, imageY, contentX, titleWidth, titleHeight } =
        data;

    return (
        <ContentLoader
            speed={2}
            className={cn(styles.container, containerClassName)}
            viewBox={`0 0 ${width} ${height}`}
        >
            <rect x={radioX} y={radioY} rx={radius} ry={radius} width={radioSize} height={radioSize} />
            <rect x={imageX} y={imageY} rx={radius} ry={radius} width={imageSize} height={imageSize} />
            <rect x={contentX} y={imageY} rx={0} ry={0} width={titleWidth} height={titleHeight} />
            <rect
                x={contentX}
                y={imageY + titleHeight + padding}
                rx={0}
                ry={0}
                width={titleWidth / 2}
                height={titleHeight}
            />
        </ContentLoader>
    );
};
